export const LeftChevron = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.0308 17.5329L8.46729 11.9694L14.0308 6.38672L14.8115 7.16749L10.0288 11.9694L14.8115 16.7521L14.0308 17.5329Z" fill="white" />
    </svg>
  )
}
